export const subscriptionKeys = {
  all: ['subscriptions'] as const,
  lists: () => [...subscriptionKeys.all, 'list'] as const,
  list: (filters?: unknown) => [...subscriptionKeys.lists(), filters] as const,
  details: () => [...subscriptionKeys.all, 'detail'] as const,
  detail: (id: string) => [...subscriptionKeys.details(), id] as const,
  balance: (familyId: string) => [...subscriptionKeys.all, 'balance', familyId] as const,
  pricing: () => [...subscriptionKeys.all, 'pricing'] as const,
  /** The hidden-tokens meter (% + content estimates) — one read for every observer. */
  allowanceMeter: () => [...subscriptionKeys.all, 'allowanceMeter'] as const,
  history: (familyId: string, storyId?: string) => [...subscriptionKeys.all, 'history', familyId, storyId ?? 'all'] as const,
};
